var site = site || {};
site.inits = [];

site.window = {
	scrollPosition: 0
};

site.device = {
	// Check if device is a touch device
	isTouch: function() {
		try {
			document.createEvent("TouchEvent");
			return true;
		} catch (e) {
			return false;
		}
	}
};


// A few layout methods
site.layout = {
	// Wrap elements into a div.row
	rowWrap: function(selectorBegin, selectorEnd, extraClasses) {
		if (selectorEnd == undefined) {
			selectorEnd = selectorBegin;
		}

		if (extraClasses == undefined) {
			extraClasses = '';
		}

		$(selectorBegin).nextUntil(selectorEnd).andSelf().add(selectorEnd)
			.wrapAll("<div class='row " +extraClasses+ "'></div>");
	}
}


site.owl = {
	// Shorthand to init owlcarousel
	init: function(id, options) {
		var $owl = $(id);
		if ($owl.length > 0) {
			$owl.addClass('owl-carousel'); // This is to fix a change made in owl 2.0.0-beta.3
			$owl.owlCarousel(options);
		}
	}
};

site.accessibility = {
	init:function() {
		$(document).keydown(function (e) {
			if (e.which === 9) {
				$('body:not(.admin)').addClass('tabbing');
			}
		});
		$(document).mousedown(function (e) {
			$('body.tabbing').removeClass('tabbing');
		});
	}
};

site.employees = {
	init: function() {
		var hash = location.hash;
		if (hash) {
			hash = hash.replace('#','.');
			var branchSort = $(hash, 'ul.branches').data('sort');
		}
		var loadSort = (branchSort) ? branchSort : 'all';

		$('.employees').mixItUp({
			layout: {
				display: 'flex'
			},
			load: {
				sort:loadSort
			},
			callbacks: {

				onMixStart: function(state, futureState){
					$('.mix').removeClass('active');
				},

				onMixEnd: function(state){
					var hash = location.hash;
					if (hash) {
						hash = hash.replace('#','.');
					}
					if (state.totalShow == 0) {

					}
					else {
						var $container = $('.employees', '.box');

						if (hash && hash != '.all') {
							$container.addClass('sorted');
						}
						else {
							$container.removeClass('sorted');
						}


						setTimeout(function() {

							$(hash).addClass('active');
						},1);
					}
				}
			}
		});
	}
};

site.frontpage = {
	init: function() {
		$('.scrollDown a').on('click', function(e){
			e.preventDefault();
			$('html,body').animate({scrollTop:$(this.hash).offset().top - 70}, 500);
		});


		$('#mainmenu .level1 > a').on('click', function (e) {
			var h = this.hash;
			history.pushState(null, null, h);
			$('html,body').animate({
				scrollTop: $(this.hash).offset().top - 70
			}, 500, function () {
				//window.location.hash = h;
			});
			e.preventDefault();
			var documentWidth = $(document).width() - 15;
			if(documentWidth < 992) {
				console.log('asdf');
				$('#mainmenuToggle').trigger('click');
			}
		});

		site.employees.init();
	}
};


// Run all the inits \o/
$(function() {
	$.each(site.inits, function(i, value) {
		var fun = new Function(value);
		fun();
	});

	site.accessibility.init();
	site.sticky.box('#pageContainer', 'sticky', -60);

	var $body = $('body');
	if ($body.is('.frontpage')) {
		site.frontpage.init();
	}

	//Responsive youtube and vimeo iframe
	$('iframe[src*="youtube.com"], iframe[src*="vimeo.com"]', '#main').each(function() {
		$(this).attr('allowfullscreen','').wrap('<div class="video" style="max-width:'+$(this).width()+'px"><div class="embed-responsive embed-responsive-16by9"></div></div>');
	});

	// Responsive tables
	if (!$body.is('.admin')) {
		$('table', '#main').wrap('<div class="table-responsive"></div>');
	}

	// Reorder language menu based on selected
	// Move is to the top
	//$li = $('.selected', '#divisions');
	//$ul = $('.menu', '#divisions');
	//$ul.prepend($li);
});
